import axios from 'axios';

const getGeolocationData = async (key: string): Promise<GeolocationData> => {
  const result = await axios.get('https://get.geojs.io/v1/ip/country.json');
  return result?.data as GeolocationData;
};

export const geoApi = {
  getGeolocationData,
};
